import React from 'react';
import ActionDelete from '@material-ui/icons/Delete';

const DeleteIcon = (props) => (
  <ActionDelete className="material-icons" label="" style={{ width: 19, height: 19 }} {...props} />
);

export default DeleteIcon;



// WEBPACK FOOTER //
// ./src/views/Common/Icons/Delete.tsx